var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-combobox',{attrs:{"items":_vm.categories,"label":_vm.$tc('common.category'),"return-object":false,"loading":_vm.pending,"item-text":"value","item-value":"value","clearable":""},model:{value:(_vm.value),callback:function ($$v, $$p) {_vm.$updateField([], $$v, undefined)},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }